<template>
  <div class="bg">
    <!-- Asia is Our Base -->
    <div class="top">
      <div class="bigTitle"><span class="redHighLight">Asia</span> is Our Base</div>
      <div class="value">Covering <span class="blueHighLight">14</span> countries & markets, with population over <span class="blueHighLight">10 million</span> people, Holden supports our clients by carrying out research studies in the region. Our proprietary panels plus APPA panels are ready for easy access to local HCP physicians, patients and consumers
      </div>
    </div>
    <div class="title">
      <span class="redHighLight">Asia</span> Access
    </div>
    <!-- map -->
    <asia-map />
    <div class="management">
      <div class="title">
        Project Management
      </div>
      <div class="value">
        <div class="left">
          International Experience Local Expertise
        </div>
        <div class="right">
          Dedicated Project Manager Single Contact Point
        </div>
        <div class="left">
          18-Hours Work Clock
        </div>
        <div class="right">
          Speed+ | Quality,Coverage & Insight
        </div>
      </div>
    </div>
    <div class="services">
      <div class="title">
        Services
      </div>
      <div class="text">
        <div class="one">
          <div class="value">
            <div class="subtitle">Qualitative Research</div>
            <div class="number">510</div>
          </div>
        </div>
        <div class="two">
          <div class="value">
            <div class="subtitle">Quantitative Research</div>
            <div class="number">1695</div>

          </div>
        </div>
        <div class="three">
          <div class="value">
            <div class="subtitle">Content Analysis</div>
            <div class="number">884</div>
          </div>
        </div>
        <div class="four">
          <div class="value">
            <div class="subtitle">Transcripts & Summary</div>
            <div class="number">1096</div>
          </div>
        </div>
      </div>
    </div>
    <div class="photo">
      <div class="photo_box_1">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/qualitative/FocusGroup/Artboard 19.png" alt="">
      </div>

      <div class="photo_box_3">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/qualitative/FocusGroup/Artboard 18.png" alt="">
      </div>
      <div class="photo_box_2">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/qualitative/FocusGroup/Artboard 17.png" alt="">
      </div>
    </div>
    <div class="research">
      <div class="title">Research Consultants</div>
      <div class="value">
        Meet our consultants who can give you our advices on project </br>design and execution in regard to your study in local market
      </div>
    </div>
    <!-- Download our Panel Book -->
    <down-load />

  </div>

</template>

<script>
import { panelDownloads, getNewsList, advertisementFlow } from "@/api/api";
import DownLoad from "@/components/downLoad";
import AsiaMap from "@/components/asiaMap";

export default {
  data() {
    return {
      downloadfile: "",
      url: "",
      isshow: true,
      downloadid: ""
    };
  },
  components: { DownLoad, AsiaMap },
  created() {
    this.loading();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  methods: {
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "asiaAccess",
          source: "",
          information: "Asia页"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "asiaAccess",
          source: this.$route.query.source,
          information: "Asia页"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    },
    btn(path) {
      // 跳转页面
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  font-family: "Nunito";
}
.bg {
  // height: 100vh;
  background-image: url(https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Homepage/Homepage_Background.png);
  background-size: cover;
  color: #1e364e;
}
.redHighLight {
  color: #e73323;
}
.blueHighLight {
  color: #4c8fd5;
  font-size: 35px;
}
.top {
  padding-top: 100px;
  .bigTitle {
    text-align: center;
    font-size: 60px;
    font-weight: 700;
  }
  .value {
    font-size: 20px;
    text-align: center;
    padding: 20px 200px;
  }
}
.title {
  font-size: 40px;
  font-weight: 700;
  text-align: center;
  padding: 30px 0;
}
.management {
  .value {
    font-size: 25px;
    padding: 0 250px;
    .right {
      text-align: right;
    }
    .left,
    .right {
      margin-bottom: 50px;
    }
  }
}
.services {
  padding: 100px 250px;
  background: linear-gradient(to bottom, rgba(255, 0, 0, 0), rgba(47, 147, 248, 0.9) 20%, rgba(47, 147, 248, 0.9) 80%, rgba(255, 0, 0, 0));
  .title {
    color: #fff;
  }
  .text {
    display: flex;
    flex-wrap: wrap;
  }
  .one,
  .two,
  .three,
  .four {
    transform: skew(-30deg);
    transform-origin: left;
    width: 50%;
    font-size: 30px;
    .value {
      transform: skew(30deg);
      transform-origin: left;
      color: #fff;
      .subtitle {
        padding-left: 50px;
      }
      .number {
        font-weight: 700;
      }
    }
  }
  .one {
    border-bottom: 5px solid #fff;
    border-right: 5px solid #fff;
    padding: 100px 50px 20px 20px;
  }
  .two {
    border-bottom: 5px solid #fff;
    padding: 100px 50px 40px 20px;
  }
  .three {
    border-right: 5px solid #fff;
    padding: 40px 50px 100px 100px;
  }
  .four {
    padding: 40px 50px 100px 50px;
  }
}
.photo {
  position: relative;
  height: 530px;
  overflow: hidden;
  .photo_box_1,
  .photo_box_2,
  .photo_box_3 {
    position: absolute;
    margin-top: 50px;
    width: 35%;
    // height: 202.5px;
    background-color: #fff;
    img {
      width: 100%;
      border: 10px solid #fff;
    }
  }
  .photo_box_1 {
    transform: rotate(-10deg);
    top: 20%;
  }
  .photo_box_2 {
    transform: rotate(10deg);
    left: 33%;
  }
  .photo_box_3 {
    transform: rotate(-10deg);
    left: 66%;
    top: 20%;
  }
}
.research{
  .value{
    text-align: center;
    font-size: 22px;
    // padding: 50px 0;
  }
}
</style>
